<template>
  <div class="page-root">
    <!-- 装饰模糊圆 -->
    <div class="decor-circle decor-left"></div>
    <div class="decor-circle decor-right"></div>

    <!-- 内容包装 -->
    <div class="page-wrap">
      <!-- 面包导航条 -->
      <div class="breadcrumb">
        <button class="back-btn" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </button>
        <span class="sep"></span>
        <span class="current">{{ title }}</span>
      </div>

      <!-- 主卡片 -->
      <section class="main-card">
        <!-- 四角L型装饰 -->
        <span class="corner corner-tl"></span>
        <span class="corner corner-tr"></span>
        <span class="corner corner-bl"></span>
        <span class="corner corner-br"></span>

        <div class="card-inner">
          <!-- 卡片头部 -->
          <div class="card-header">
            <div class="header-left">
              <h1 class="main-title">{{ title }}</h1>
            </div>
          </div>

          <!-- 健康预测：顶部tab筛选（健康预测 / 五运信息） -->
          <div class="result-tabs" v-if="showResultTabs">
            <button
              type="button"
              class="tab-btn"
              :class="{ active: activeTab === 'predict' }"
              @click="activeTab = 'predict'"
            >
              健康预测
            </button>
            <button
              type="button"
              class="tab-btn"
              :class="{ active: activeTab === 'wuyun' }"
              @click="activeTab = 'wuyun'"
            >
              五运信息
            </button>
          </div>

          <!-- 结果文本区 -->
          <div class="result-list">
            <p v-for="(item, index) in displayLines" :key="index">
              <WordSegment
                v-if="
                  (serviceIndex == 4 && index == 2) ||
                  (serviceIndex == 1 && item.includes('适宜穴位'))||
                  (serviceIndex == 1 && item.includes('适宜按摩穴位'))
                "
                :inputText="item"
                :list="list"
              />
              <span v-else>{{ item }}</span>
            </p>
            <p
              class="remark"
              v-if=" serviceIndex == 4||activeTab === 'wuyun'"
            >
              （备注：可点击以上穴位名称，获取详细信息。）
            </p>
          </div>
        </div>
      </section>

      <!-- 底部按钮区 -->
      <div class="action-bar" v-if="results.length > 0">
        <button class="ai-btn" @click="sendToAiDialog">
          <i class="el-icon-chat-dot-round"></i>
          <span>一键输入到AI对话框</span>
        </button>
        <button class="next-btn" v-if="serviceIndex == 9" @click="nextStep">下一步</button>
      </div>
    </div>
  </div>
</template>

<script>
import WordSegment from "./WordSegment.vue";
import { EventBus } from "../js/eventbus.js";
import utils from "../js/utils.js";
export default {
  data() {
    return {
      results: [],
      title: "",
      list: [],
      serviceIndex: "",
      consultInfo: "",
      visitRecordId:"",
      fromPath: "/",
      activeTab: "predict",
      normalPredictionInfo: "",
    };
  },
  components: {
    WordSegment,
  },
  created() {
    var serviceInfo = JSON.parse(sessionStorage.getItem("serviceInfo"));
    var patientId = serviceInfo.patientId;
    var useDate = serviceInfo.useDate;
    var useDays = serviceInfo.useDays;
    var serviceIndex = serviceInfo.serviceIndex;
    this.serviceIndex = serviceInfo.serviceIndex;
    var params = {
      patientId: patientId,
    };
    console.log("created");
    // console.log("serviceIndex:"+serviceIndex)
    var url = "";
    if (serviceIndex == 1) {
      document.title = "健康预测结果";
      this.title = "健康预测";
      url = "/api/health/v1/disease";
      params.toPredictDay = useDate.replace(/-/g, "");
      params.predictDays = useDays;
    } else if (serviceIndex == 2) {
      document.title = "茶饮结果";
      this.title = "茶饮";
      url = "/api/health/v1/dietTherapy";
    } else if (serviceIndex == 3) {
      document.title = "经络调理结果";
      this.title = "经络调理";
      url = "/api/health/v1/massage";
    } else if (serviceIndex == 4) {
      document.title = "针灸结果";
      this.title = "针灸";
      url = "/api/health/v1/acupuncture";
    } else if (serviceIndex == 5) {
      document.title = "中成药结果";
      this.title = "中成药";
      url = "/api/health/v1/medicine";
    } else if (serviceIndex == 9) {
      document.title = "私人定制养生茶结果";
      this.title = "私人定制养生茶";
      url = "/api/health/v1/customTea";
      params.toPredictDay = useDate.replace(/-/g, "");
      params.predictDays = useDays;
    } else if (serviceIndex == 10) {
      document.title = "药食同源结果";
      this.title = "药食同源";
      url = "/api/health/v1/medicine";
    } else if (serviceIndex == 11) {
      document.title = "六气汤结果";
      this.title = "六气汤";
      url = "/api/health/v1/liuQiYin";
    } else if (serviceIndex == 12) {
      document.title = "新健康预测";
      this.title = "新健康预测";
      url = "/api/health/v1/newDisease";
      params.toPredictDay = useDate.replace(/-/g, "");
      params.predictDays = useDays;
    }
    if (serviceIndex != 1 && serviceIndex != 9) {
      params.toDoDay = useDate;
      if (!this.utils.isEmptyStr(useDays)) {
        params.takeDays = useDays;
      }
    }

    console.log(url);
    this.wjtHttp.post(
      this,
      url,
      params,
      false,
      (res) => {
        var data = res.data;
        if (data.code == 200) {
          var rs = "";
          if (serviceIndex == 9) {
            rs = data.data.customTeaResult.split("\n");
            this.visitRecordId = data.data.visitRecordId;
          } else if (serviceIndex == 1) {
            // 健康预测接口返回新结构：data为结果文本，patient为患者信息
            rs = data.data.split("\n");
            this.consultInfo = data.patient;
            // 五运信息（normalPredictionInfo 可能为多行文本或JSON对象/数组）
            if (data.normalPredictionInfo) {
              this.normalPredictionInfo = data.normalPredictionInfo;
            }
          } else {
            rs = data.data.split("\n");
          }
          var newRS = [];
          rs.forEach((val, index) => {
            if (val.length != 0) {
              newRS.push(val.replace(/ /g, ""));
            }
          });
          this.results = newRS;
        } else {
          this.$message({
            message:
              data.msg && data.msg.length > 0
                ? data.msg
                : "搜索异常，请联系管理员",
            type: "error",
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
    // this.get()
  },
  computed: {
    // 是否展示顶部tab（仅健康预测且有五运信息时）
    showResultTabs() {
      return this.serviceIndex == 1 && this.wuyunLines.length > 0;
    },
    // 当前tab展示的内容行
    displayLines() {
      if (this.serviceIndex == 1 && this.activeTab === "wuyun" && this.wuyunLines.length > 0) {
        return this.wuyunLines;
      }
      return this.results;
    },
    // 将五运信息（normalPredictionInfo）解析为展示行
    wuyunLines() {
      var info = this.normalPredictionInfo;
      if (!info) return [];
      if (typeof info === "string") {
        var trimInfo = info.trim();
        // 若是JSON字符串，则解析后按对象处理
        if ((trimInfo.charAt(0) === "{" || trimInfo.charAt(0) === "[") && trimInfo.indexOf("\n") === -1) {
          try {
            info = JSON.parse(trimInfo);
          } catch (e) {
            info = info.split("\n");
          }
        } else {
          info = info.split("\n");
        }
      }
      var lines = [];
      var collect = (val, prefix) => {
        if (val === null || val === undefined || val === "") return;
        if (typeof val === "string" || typeof val === "number") {
          String(val).split("\n").forEach((v) => {
            v = String(v).replace(/ /g, "");
            if (v.length > 0) lines.push(prefix + v);
          });
        } else if (Array.isArray(val)) {
          val.forEach((item) => collect(item, prefix));
        } else if (typeof val === "object") {
          Object.keys(val).forEach((key) => {
            var item = val[key];
            if (item === null || item === undefined || item === "") return;
            if (typeof item === "object") {
              collect(item, prefix);
            } else {
              collect(item, prefix + "【" + key + "】");
            }
          });
        }
      };
      collect(info, "");
      return lines;
    },
  },
  methods: {
    goBack() {
      this.$router.replace('/');
    },
    nextStep() {
      this.$router.push({
        path: "/CUSTOMIZEDPrescription",
        query: {
          visitRecordId: this.visitRecordId,
        },
      });
    },
    handleMouseOver() {
      console.log(1111);
    },
    get() {
      this.wjtHttp.get(
        this,
        "/api/business/acupointDetails/listAll",
        {},
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.list = data.data;
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "搜索异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    sendToAiDialog() {
      // 获取健康预测的开始日期和持续天数
      const serviceInfo = JSON.parse(sessionStorage.getItem("serviceInfo"));
      const useDate = serviceInfo.useDate || '';
      const useDays = serviceInfo.useDays || '';
      
      // 构建患者信息行（姓名、健康开始日期、健康持续天数）
      let patientLine = '';
      if (this.consultInfo && typeof this.consultInfo === 'object' && this.consultInfo.name) {
        const blurredName = utils.blurName(this.consultInfo.name);
        patientLine = `患者：${blurredName}，健康开始日期：${useDate}，健康持续天数：${useDays}天`;
      } else if (this.consultInfo && typeof this.consultInfo === 'string' && this.consultInfo.length > 0) {
        // 如果consultInfo是字符串，尝试解析JSON
        try {
          const info = JSON.parse(this.consultInfo);
          if (info.name) {
            const blurredName = utils.blurName(info.name);
            patientLine = `患者：${blurredName}，健康开始日期：${useDate}，健康持续天数：${useDays}天`;
          }
        } catch (e) {
          // 忽略解析错误
        }
      }
      
      // 将当前tab内容行合并为字符串（健康预测结果 或 五运信息）
      const resultText = this.displayLines.join('\n');
      
      // 组合最终文本：患者信息行 + 换行 + 当前tab内容
      let text = '';
      if (patientLine) {
        text = patientLine + '\n' + resultText;
      } else {
        text = resultText;
      }

      // 通过事件总线发送
      EventBus.$emit('ai-input-text', {
        text: text,
        source: 'health_prediction',
        serviceIndex: this.serviceIndex
      });
      this.$message.success('已填充到AI对话框');
    },
  },
  beforeRouteEnter(to, from, next) {
    next(function(vm) {
      vm.fromPath = from.path;
    });
  },
};
</script>

<style scoped>
/* ============ 页面根容器 ============ */
.page-root {
  position: relative;
  min-height: 100vh;
  background: #f3f9f8;
  overflow: hidden;
  font-family: 'Noto Sans SC', system-ui, sans-serif;
  color: #1a1a1a;
  padding-bottom: 40px;
}

/* ============ 装饰模糊圆 ============ */
.decor-circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  pointer-events: none;
  z-index: 0;
}
.decor-left {
  left: -112px;
  top: 80px;
  width: 320px;
  height: 320px;
  background: rgba(0, 151, 152, 0.08);
}
.decor-right {
  right: 0;
  top: 0;
  width: 384px;
  height: 288px;
  background: rgba(200, 169, 110, 0.1);
}

/* ============ 内容包装 ============ */
.page-wrap {
  position: relative;
  z-index: 1;
  max-width: 1152px;
  margin: 0 auto;
  padding: 40px 24px;
}

/* ============ 面包导航条 ============ */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(0, 151, 152, 0.25);
  background: #ffffff;
  color: #009798;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 20px;
  border-radius: 9999px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}
.back-btn:hover {
  background: #e3f3f1;
  border-color: rgba(0, 151, 152, 0.4);
}
.back-btn i {
  font-size: 16px;
  font-weight: bold;
}
.breadcrumb .sep {
  width: 1px;
  height: 20px;
  background: #c7dcd8;
}
.breadcrumb .current {
  font-size: 18px;
  font-weight: 600;
  color: #304744;
}

/* ============ 主卡片 ============ */
.main-card {
  position: relative;
  border: 1px solid #d3e6e3;
  background: #ffffff;
  border-radius: 32px;
  box-shadow: 0 2px 10px rgba(23, 61, 59, 0.05);
}

/* 四角L型装饰 */
.corner {
  position: absolute;
  width: 64px;
  height: 64px;
  pointer-events: none;
}
.corner-tl {
  top: 24px;
  left: 24px;
  border-left: 4px solid rgba(0, 151, 152, 0.35);
  border-top: 4px solid rgba(0, 151, 152, 0.35);
  border-top-left-radius: 8px;
}
.corner-tr {
  top: 24px;
  right: 24px;
  border-right: 4px solid rgba(0, 151, 152, 0.35);
  border-top: 4px solid rgba(0, 151, 152, 0.35);
  border-top-right-radius: 8px;
}
.corner-bl {
  bottom: 24px;
  left: 24px;
  border-left: 4px solid rgba(0, 151, 152, 0.35);
  border-bottom: 4px solid rgba(0, 151, 152, 0.35);
  border-bottom-left-radius: 8px;
}
.corner-br {
  bottom: 24px;
  right: 24px;
  border-right: 4px solid rgba(0, 151, 152, 0.35);
  border-bottom: 4px solid rgba(0, 151, 152, 0.35);
  border-bottom-right-radius: 8px;
}

.card-inner {
  position: relative;
  padding: 40px;
}

/* ============ 卡片头部 ============ */
.card-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid #e6efed;
  padding-bottom: 24px;
  margin-bottom: 24px;
}
@media (min-width: 768px) {
  .card-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}
.header-left {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.badge {
  display: inline-flex;
  align-items: center;
  background: #eaf6f4;
  color: #009798;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 9999px;
  width: fit-content;
}
.main-title {
  font-size: 32px;
  font-weight: 700;
  color: #304744;
  margin: 0;
  line-height: 1.2;
}
.ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #1e90ff;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(30, 144, 255, 0.2);
  transition: all 0.25s ease;
  flex-shrink: 0;
}
.ai-btn:hover {
  background: #1873cc;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(30, 144, 255, 0.3);
}
.ai-btn i {
  font-size: 18px;
}

/* ============ 健康预测顶部Tab筛选 ============ */
.result-tabs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: -8px 0 24px;
}
.tab-btn {
  border: 1px solid #d3e6e3;
  background: #ffffff;
  color: #527f77;
  font-size: 15px;
  font-weight: 600;
  padding: 9px 26px;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.tab-btn:hover {
  background: #f3f9f8;
  color: #009798;
}
.tab-btn.active {
  background: #009798;
  border-color: #009798;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 151, 152, 0.25);
}

/* ============ 结果文本区 ============ */
.result-list {
  display: flex;
  flex-direction: column;
}
.result-list > p {
  font-size: 18px;
  line-height: 36px;
  color: #0069bd;
  margin: 6px 0;
  text-align: left;
}
.result-list .remark {
  font-size: 16px;
  color: #304744;
  margin-top: 12px;
}

/* ============ 底部按钮区 ============ */
.action-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
}
.next-btn {
  width: 384px;
  max-width: 100%;
  border-radius: 40px;
  font-size: 18px;
  font-weight: 600;
  height: 50px;
  background: #009798;
  color: #ffffff;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 151, 152, 0.2);
  transition: all 0.25s ease;
}
.next-btn:hover {
  background: #007e7f;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 151, 152, 0.3);
}

/* ============ 兼容旧 Element 样式覆盖 ============ */
.page-root >>> .el-message-box,
.page-root >>> .el-notification {
  font-family: inherit;
}
</style>
